import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    this.pollChargeableSourceResult();
  }

  async pollChargeableSourceResult() {
    let pollAttempts = 0;
    let checkForResult = async function() {
      if (++pollAttempts > 30) {
        this.showError();
        return;
      }
      let response = await fetch(
        `/salons/${this.data.get('domainName')}/chargeable_sources/${this.data.get("purchase-number")}`
      );
      if (response.status != 200) {
        this.showError();
        return;
      }
      let result = await response.json();
      if (!result.status) {
        setTimeout(checkForResult, 1000);
      } else {
        this.redirect(result.status);
      }
    }.bind(this);
    await checkForResult();
  }

  redirect(status) {
    if (status === "OK") {
      window.location.href = `${window.location.protocol}//${window.location.host}/salons/${this.data.get('domainName')}?purchase_number=${this.data.get("purchase-number")}#success`;
    } else {
      window.location.href = `${window.location.protocol}//${window.location.host}/salons/${this.data.get('domainName')}?purchase_number=${this.data.get("purchase-number")}#payment`;
    }
  }
  showError() {
    //TODO?
  }
}
